<template>
  <HeaderOther :h1="title" :text="text" />
  <main>
    <section>
      <div class="pd70">
        <div class="error-box">
          <template v-if="error.statusCode == 404">
            <p>
              Страница по адресу <span class="path">{{ route.path }}</span> не
              найдена.
            </p>
            <p>
              Возможно Вы ввели не верный адрес или страница более не доступна
              по причине ее не актуальности.
            </p>
          </template>

          <p v-else>Извините, произошла непредвиденная ошибка.</p>

          <NuxtLink to="/" class="mb">На галвную страницу</NuxtLink>
        </div>
      </div>
    </section>
    <BlockWhyWe />
    <BlockZakaz />
    <BlockAchievements />
    <BlockContact />
  </main>
</template>

<script setup>
const route = useRoute();
const props = defineProps(["error"]);
const title = ref("" + props.error.statusCode);
const text = ref("Извините, произошла непредвиденная ошибка.");
if (props.error.statusCode == 404) {
  title.value += " Страница не найдена";
  text.value = "Извините, произошла ошибка. Запрошенная страница не найдена!";
}
useHead({
  title,
});
</script>
